import { Dialog, DialogContent } from "@/components/ui/dialog";

interface CalendarDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const CalendarDialog = ({ open, onOpenChange }: CalendarDialogProps) => {
  // Replace this URL with your actual calendar booking URL (Calendly, Cal.com, etc.)
  const calendarUrl = "https://calendly.com/your-calendar-link";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl h-[80vh] p-0">
        <iframe
          src={calendarUrl}
          width="100%"
          height="100%"
          frameBorder="0"
          className="rounded-lg"
          title="Book a Demo"
        />
      </DialogContent>
    </Dialog>
  );
};

export default CalendarDialog;
